import {
  ChartDataSets,
  ChartOptions,
  ChartScales,
  ChartXAxe,
  ChartYAxe,
  TickOptions,
  TimeScale,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import React from "react";
import { Bar } from "react-chartjs-2";
import { baseOption, colors } from "../../utils";

interface BarChartOptions {
  data: any[];
}

const options: ChartOptions = {
  scales: {
    xAxes: [
      {
        stacked: true,
        position: "bottom",
        type: "time",
        distribution: "linear",
        time: {
          unitStepSize: 3,
          minUnit: "day",
          unit: "day",
          displayFormats: {
            day: "D MMM",
          },
          tooltipFormat: "D MMM YYYY",
        } as TimeScale,
        scaleLabel: {
          display: true,
          labelString: "Time",
          fontColor: "#1d344e",
        },
      },
    ] as ChartXAxe[],
    yAxes: [
      {
        stacked: true,
        position: "left",
        ticks: {
          beginAtZero: true,
        } as TickOptions,
        scaleLabel: {
          display: true,
          labelString: "Total number",
          fontColor: "#1d344e",
        },
      },
    ] as ChartYAxe[],
  } as ChartScales,
  legend: {
    display: true,
    position: "right",
    labels: {
      padding: 20,
    },
  },
  maintainAspectRatio: false,
  plugins: {
    datalabels: {
      color: "#fff",
      anchor: "center",
      align: "center",
      font: {
        weight: "bold",
      },
      formatter: (value: number | { y?: number }) => {
        const count = typeof value === "object" && value !== null ? value.y : value;
        return count ? count : "";
      },
    },
  },
};

export const BarChart: React.FC<BarChartOptions> = (props) => {
  const { data } = props;

  return (
    <Bar
      data={{
        datasets: data.map((row, index) => {
          return {
            ...row,
            ...baseOption(colors[index]),
          } as ChartDataSets;
        }),
      }}
      options={options}
      plugins={[ChartDataLabels]}
    />
  );
};
